(function () {
    async function saveStorefrontToCart() {
        const storefront =
            localStorage.getItem('omni_storefront');

        if (!storefront) {
            console.log(
                'No storefront referral found.'
            );

            return;
        }

        try {
            const response = await fetch(
                '/cart/update.js',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        attributes: {
                            storefront_slug: storefront
                        }
                    })
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Cart update failed: ${response.status}`
                );
            }

            const cart = await response.json();

            console.log(
                'Storefront saved to Shopify cart:',
                cart.attributes
            );

        } catch (error) {
            console.error(
                'Failed to save storefront to cart:',
                error
            );
        }
    }

    saveStorefrontToCart();
})();
